// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3jnIa","validationTips":"StatementDescriptor_validationTips__2pBwZ"};